module.exports = __webpack_public_path__ + "static/media/green_location_pin.747d3fe3.svg";